import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  new: {
    description: 'the text to display in this badge that will indicate a New Feature',
    defaultMessage: 'New',
    id: 'Dlnx6w',
  },
});
